import { CellDecorator } from '../Enum/TableDecorator';
import { InterestPerProduct } from '../Interface/Response/Interest/InterestPerProduct';
import { Cell, HeaderCell, Row } from '../Interface/Hook/Interest/InterestTableDTO';
import { InterestPerProductTableDTO } from '../Interface/Hook/Interest/InterestPerProductTableDTO';

const reduceTablePerProductData = (interests: InterestPerProduct): InterestPerProductTableDTO => {
    const headers: HeaderCell[] = interests.riskCategories.map(riskCategory => ({
        value: riskCategory.label,
        prop: riskCategory.label,
        sortable: true,
    }));

    headers.unshift({
        value: '',
        prop: 'label',
    });

    const data = interests.periods.reduce((acc: Row[], curValue) => {
        const cells: Cell[] = [];
        cells.push({ value: curValue.name });
        curValue.interests.forEach(interest =>
            cells.push({
                value: interest,
                decorator: CellDecorator.Interest,
            }),
        );
        acc.push({ cells });

        return acc;
    }, []);

    return { data, headers, extraInterest: interests.extraInterest, messages: interests.messages };
};

export default reduceTablePerProductData;
